// extracted by mini-css-extract-plugin
export default {"LogoWordmark":"sidebar-profile_LogoWordmark__MvGtN","pin":"sidebar-profile_pin__sgJtU"};